import { render } from "./TranslationSettings.vue?vue&type=template&id=3e8ad9f3"
import script from "./TranslationSettings.vue?vue&type=script&lang=js"
export * from "./TranslationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__